import { CButton, CCol, CInputGroup, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { formatDate, formatDateTime } from "src/shared/Format/dateFormat";
import CommonList from "src/views/common/CommonList";
import PaymentTransactionHistory from "./ModalPaymentTransactionHistory";
import Badge from "src/views/common/controller/Badge";

const LotListViewGoDownRentFeeExtension = (props) => {
  const { authenticated } = Auth();
  const userRole = authenticated.role;
  const [gDRFEListData, setGDRFEListData] = useState([]); // List data manage
  const [isDisplay, setIsDisplay] = useState(false);

  const [
    selectedGoDownRentFeeExtensionTDSFile,
    setselectedGoDownRentFeeExtensionTDSFile,
  ] = useState();
  const [
    fileEventGoDownRentFeeExtensionTDSFile,
    setfileEventGoDownRentFeeExtensionTDSFile,
  ] = useState(false);
  const [showpaymentHistory, setshowpaymentHistory] = useState(false);
  const [paymentTransactionHistory, setpaymentTransactionHistory] = useState(
    []
  );
  const [popupGRFEId, setpopupGRFEId] = useState(0);

  useEffect(() => {
    setpopupGRFEId(0);
    setGDRFEListData(props.GDRFEListData);
    setIsDisplay(props.GDRFEListData.length > 0 ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.GDRFEListData]);

  const fieldsGodownRentExtension = [
    {
      key: "startDatedateformat",
      label: "Start Date",
    },
    {
      key: "enddateformat",
      label: "End Date",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "tdS_GoDownRentFeeExtension",
      label: "TDS",
      sorter: false,
      filter: false,
    },

    {
      key: "goDownRentFeeExtension_CGST",
      label: "CGST",
      sorter: false,
      filter: false,
    },
    {
      key: "goDownRentFeeExtension_SGST",
      label: "SGST",
      sorter: false,
      filter: false,
    },
    {
      key: "goDownRentFeeExtension_IGST",
      label: "IGST",
      sorter: false,
      filter: false,
    },
    {
      key: "PaymentStatus",
      label: "Status",
    },
    // {
    //   key: "paymentdateformat",
    //   label: "Payment Date",
    // },
    // {
    //   key: "action",
    //   label: "",
    // },
  ];
  const SetDateFromate = (value) => {
    return (
      <td className="py-2">
        <span>{value === null ? "" : formatDate(value)}</span>
      </td>
    );
  };

  let scopedSlotsGodownRentList = {
    startDatedateformat: (item, index) => {
      return SetDateFromate(item.startDate);
    },
    enddateformat: (item, index) => {
      return SetDateFromate(item.endDate);
    },

    paymentdateformat: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.paymentDate === null ? "" : formatDateTime(item.paymentDate)}
          </span>
        </td>
      );
    },

    PaymentStatus: (item, index) => {
      return (
        <td className="py-2">
          {item.goDownRentFeeExtensionPaymentStatus === "Paid" ? (
            <Badge color="success" label="Paid" className="badgeFont100" />
          ) : item.goDownRentFeeExtensionPaymentStatus === "Pending" ? (
            <Badge
              color="warning"
              label={item.goDownRentFeeExtensionPaymentStatus}
              className="badgeFont100"
            />
          ) : (
            <Badge
              color="danger"
              label={item.goDownRentFeeExtensionPaymentStatus}
              className="badgeFont100"
            />
          )}
        </td>
      );
    },
  };

  const GodownRentFeeExtensionTDSForm = async (id, grfeId) => {
    let e = fileEventGoDownRentFeeExtensionTDSFile;
    if (e !== false) {
      if (authenticated) {
        if (e.target.files[0].type === "application/pdf") {
          e.preventDefault();
          // setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadGoDownRentFeeExtensionTDSFile/${id}/${grfeId}/${e.target.files[0].name}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            alert("Uploaded Successfully!");
            setselectedGoDownRentFeeExtensionTDSFile();
            setfileEventGoDownRentFeeExtensionTDSFile(false);
            props.getGoDownRentFeeExtensionList(props.viewListDetails.lotId);
            //window.location.reload();
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };

  const ViewBankTransaction = async (lotId, paymentType, grfeId) => {
    props.setIdForPaymentHistory(lotId);
    props.setTypeForPaymentHistory(paymentType);
    setpopupGRFEId(grfeId);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "PaymentHistory/GetPaymentHistory",
      "POST",
      header,
      JSON.stringify({
        LotId: lotId,
        PaymentType: paymentType,
        otherId: grfeId,
      })
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setpaymentTransactionHistory(jsonobj);
    } else {
      setpaymentTransactionHistory([]);
    }

    setshowpaymentHistory(true);
  };
  // const handleDownloadGoDownRent = async (lotPaymentId) => {
  //   await apiDownloadDocument(
  //     `${props.viewListDetails.godownRentDownloadURL}`,
  //     `${downloadUrl}/${props.viewListDetails.godownRentDownloadURL}`
  //   ).then((res) => {
  //     if (res.success) alert(res.message);
  //     else alert(res.message);
  //   });
  // };

  const payGoDownRentFeeExtension = async (
    amount,
    isWithOutTDS,
    tds_path,
    grfeid
  ) => {
    if (isWithOutTDS && tds_path === "") {
      alert("Please upload the tds certficate");
    } else {
      props.ConfirmationPopupHandler(
        8,
        1,
        "Are you sure you want to proceed for Payment?",
        amount,
        props.viewListDetails.lotId,
        0,
        0,
        0, //props.viewListDetails.godownRentLateFee,
        0,
        0,
        0,
        0,
        isWithOutTDS,
        tds_path,
        grfeid
      );
    }
  };

  return (
    <div key={"LotListViewGoDownRentFeeExtension"}>
      <PaymentTransactionHistory
        key={"paymentTransactionHistory"}
        setshowpaymentHistory={setshowpaymentHistory}
        showpaymentHistory={showpaymentHistory}
        paymentTransactionHistory={paymentTransactionHistory}
        LotId={props.viewListDetails.lotId}
        paymentType={"GRE"}
        grfeId={popupGRFEId}
        setpaymentTransactionHistory={setpaymentTransactionHistory}
      />

      {isDisplay === true && (
        <>
          <CRow className="pl-1 pr-1 pt-3 mt-3">
            <CCol className="mb-2" xl={12}>
              <h3>Godown Rent Fee Extension</h3>
              <hr />
            </CCol>
          </CRow>
          {gDRFEListData?.map((item, index) => (
            <div className="mb-2">
              <div className="viewTable pl-1 pr-1">
                {item && (
                  <CommonList
                    key={"List_" + index}
                    listName=""
                    items={[item]}
                    fields={fieldsGodownRentExtension}
                    loading={false}
                    disabledprev={true}
                    disablednext={true}
                    displayPaggingButton={false}
                    scopedSlots={scopedSlotsGodownRentList}
                  />
                )}
              </div>

              <CRow className="pl-2 pr-1" key={"Update_" + index}>
                <CCol className="mb-2 " xl={12}>
                  <CRow className={"mt-2"}>
                    {item.goDownRentFeeExtensionPaymentId > 0 &&
                    item.isGoDownRentPaymentPaid ? (
                      // && authenticated.role === "Bidder"
                      <>
                        <CCol
                          className="payment-label col-9"
                          dangerouslySetInnerHTML={{
                            __html:
                              item.goDownRentFeeExtensionPaymentDescription,
                          }}
                        ></CCol>
                        {(item.payGoDownRentFeeExtension !== "0.00" ||
                          item.payGoDownRentFeeExtension_without_tds !==
                            "0.00") && (
                          <CButton
                            color="info"
                            className="ml-2 mt-1"
                            style={{ height: "35px" }}
                            onClick={() =>
                              ViewBankTransaction(
                                props.viewListDetails.lotId,
                                "GRE",
                                item.id
                              )
                            }
                          >
                            History
                          </CButton>
                        )}
                        <CButton
                          color="info"
                          className="ml-2 mt-1"
                          style={{ height: "35px" }}
                          onClick={() =>
                            props.PaymentStatusViewHanlder(
                              item.goDownRentFeeExtensionPaymentTranId
                            )
                          }
                        >
                          Receipt
                        </CButton>
                        {/* {props.GDRFEListData.goDownRentFeeExtensionPaymentStatus ===
                    "Paid" && (
                    <CButton
                      color="info"
                      className="ml-2 mt-1"
                      style={{  height: "35px" }}
                      onClick={() =>
                        handleDownloadGoDownRent(
                          props.GDRFEListData.goDownRentFeeExtensionDownloadURL
                        )
                      }
                    >
                      Download
                    </CButton>
                  )} */}
                      </>
                    ) : (
                      <>
                        {userRole === "Bidder" &&
                          item?.payGoDownRentFeeExtension !== "0.00" &&
                          item?.status !== "Success" &&
                          props.viewListDetails.isLotLeftHOApproval !==
                            true && (
                            <CButton
                              color="info"
                              className="ml-2 mt-1"
                              onClick={() =>
                                payGoDownRentFeeExtension(
                                  item?.payGoDownRentFeeExtension,
                                  false,
                                  "",
                                  item.id
                                )
                              }
                            >
                              Pay Now = {item?.payGoDownRentFeeExtension}
                            </CButton>
                          )}
                        {userRole === "Bidder" &&
                          item?.payGoDownRentFeeExtension_without_tds !==
                            "0.00" &&
                          item?.status !== "Success" &&
                          props.viewListDetails.isLotLeftHOApproval !==
                            true && (
                            <CButton
                              color="info"
                              className="ml-2 mt-1"
                              onClick={() =>
                                payGoDownRentFeeExtension(
                                  item?.payGoDownRentFeeExtension_without_tds,
                                  true,
                                  item.goDownRentFeeExtension_tds_path,
                                  item.id
                                )
                              }
                            >
                              Pay After TDS ={" "}
                              {item?.payGoDownRentFeeExtension_without_tds}
                            </CButton>
                          )}
                      </>
                    )}
                    {item.goDownRentFeeExtension_tds_path !== "" && (
                      <a
                        target="_blank"
                        href={`${downloadUrl}/${item.goDownRentFeeExtension_tds_path}`}
                        rel="noreferrer"
                      >
                        <CButton className="ml-2 mt-1" color="info">
                          View TDS Challan
                        </CButton>
                      </a>
                    )}
                    {item.isPaymentHistory === true &&
                      item.goDownRentFeeExtensionPaymentStatus !== "Paid" &&
                      (item.payGoDownRentFeeExtension !== "0.00" ||
                        item.payGoDownRentFeeExtension_without_tds !==
                          "0.00") && (
                        <CButton
                          color="info"
                          className="ml-2 mt-1"
                          style={{ height: "35px" }}
                          onClick={() =>
                            ViewBankTransaction(
                              props.viewListDetails.lotId,
                              "GRE",
                              item.id
                            )
                          }
                        >
                          History
                        </CButton>
                      )}
                  </CRow>
                </CCol>
                {item.goDownRentFeeExtensionPaymentStatus !== "Paid" &&
                  authenticated.role === "Bidder" &&
                  item.goDownRentFeeExtension_tds_path === "" &&
                  props.viewListDetails.isLotLeftHOApproval !== true && (
                    <CCol xl={4}>
                      <CInputGroup className="mb-3">
                        <div className="custom-file">
                          <input
                            name="file"
                            disabled={
                              item.goDownRentFeeExtension_tds_path !== ""
                            }
                            id="inputGroupFile01"
                            type="file"
                            accept=".pdf"
                            className="custom-file-input"
                            onChange={(e) => {
                              setfileEventGoDownRentFeeExtensionTDSFile(e);
                              setselectedGoDownRentFeeExtensionTDSFile(
                                e.target.files[0]
                              );
                            }}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            {selectedGoDownRentFeeExtensionTDSFile ? (
                              selectedGoDownRentFeeExtensionTDSFile.name
                            ) : (
                              <>Choose file</>
                            )}
                          </label>
                        </div>
                        <div>
                          <CButton
                            className="ml-3 mt-1"
                            color="success"
                            disabled={
                              item.goDownRentFeeExtension_tds_path !== ""
                            }
                            onClick={() =>
                              GodownRentFeeExtensionTDSForm(
                                props.viewListDetails.lotId,
                                item.id
                              )
                            }
                            // enabled={uploadBtn === false ? true : false}
                          >
                            Upload TDS Challan
                          </CButton>
                        </div>
                      </CInputGroup>
                    </CCol>
                  )}
              </CRow>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default LotListViewGoDownRentFeeExtension;
